/**
 * A/B Test March 2017
 *
 * Use Groundhog instead of Rich Relevance
 *
 * @param state Redux state
 * @returns True if the SS_RRGH cookie indicates to use Groundhog
 */
export function useGroundhog(state) {
    return _.get(state, 'core.ab.SS_RRGH', '') === "GROUNDHOG";
}

/**
 * TODO: UW-14895 - remove when SS_PDPTILETYPE test is over
 * Get the tile type override cookie value
 * @param {object} Cookies cookie service
 * @param {string} tileTypeCookieKey tile type cookie key name
 * @returns {string} cookie value or empty
 */
export function getTileTypeOverride(Cookies, tileTypeCookieKey) {
    const tileTypeWhitelist = [
        'NO_DETAILS',
        'TITLE_ONLY',
        'TITLE_AND_PRICE',
        'PRICE_ONLY'
    ];
    const tileTypeCookieValue = Cookies.getCookieByName(tileTypeCookieKey);
    const isValidTileTypeValue = tileTypeWhitelist.includes(tileTypeCookieValue);

    return isValidTileTypeValue ? tileTypeCookieValue : '';
}
